import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  addProfileAppearance,
  editProfileAppearance,
  readProfileAppearanceByProfileId,
  removeProfileAppearance,
} from "./thunkAction";

const initialState = {
  profileAppearance: {},
  loading: false,
  error: null,
  isLoadingProfileAppearance: false,
  profileAppearanceError: null,
};

const profileAppearanceSlice = createSlice({
  name: "profileAppearanceManage",
  initialState,
  reducers: {
    clearProfileAppearance(state) {
      state.profileAppearance = {};
    },
    setProfileAppearance(state, action) {
      state.profileAppearance = _.get(action, "payload", {});
    },
    resetProfileError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // readProfileAppearanceByProfileId
      .addCase(readProfileAppearanceByProfileId.pending, (state) => {
        state.loading = true;
      })
      .addCase(readProfileAppearanceByProfileId.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.profileAppearance = _.get(action, "payload", {});
      })
      .addCase(readProfileAppearanceByProfileId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // addProfileAppearance
      .addCase(addProfileAppearance.pending, (state) => {
        state.isLoadingProfileAppearance = true;
        state.profileAppearanceError = null;
      })
      .addCase(addProfileAppearance.fulfilled, (state, action) => {
        state.isLoadingProfileAppearance = false;
        state.profileAppearance = _.get(action, "payload", {});
      })
      .addCase(addProfileAppearance.rejected, (state, action) => {
        state.isLoadingProfileAppearance = false;
        state.profileAppearanceError = action.payload;
      })
      // editProfileAppearance
      .addCase(editProfileAppearance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProfileAppearance.fulfilled, (state, action) => {
        state.loading = false;
        state.profileAppearance = _.get(action, "payload", {});
      })
      .addCase(editProfileAppearance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // removeProfileAppearance
      .addCase(removeProfileAppearance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeProfileAppearance.fulfilled, (state, action) => {
        state.loading = false;
        state.profileAppearance = {};
      })
      .addCase(removeProfileAppearance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const profileAppearanceReducer = profileAppearanceSlice.reducer;

export const profileAppearanceAction = profileAppearanceSlice.actions;
